import { styled, Box, Button } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  // borderRadius: theme.shape.borderRadius, // Optional, matching reference
}));

export const ActionButton = styled(Button)<{ variant?: 'contained' | 'outlined'; colorType?: 'green' | 'red' | 'blue' | 'gray' }>(({ theme, variant = 'outlined', colorType = 'green' }) => ({
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '8px',
  padding: '8px',
  boxShadow: 'none',
  ...(variant === 'contained' && colorType === 'green' && {
    backgroundColor: '#52786F',
    color: '#fff',
    '&:hover': { backgroundColor: '#3E5C54' },
  }),
  ...(variant === 'outlined' && colorType === 'green' && {
    borderColor: '#52786F',
    color: '#52786F',
    '&:hover': { backgroundColor: '#F0FDF9', borderColor: '#3E5C54' },
  }),
  ...(colorType === 'blue' && {
    backgroundColor: '#EEF2FF',
    color: '#4F46E5',
    '&:hover': { backgroundColor: '#E0E7FF' },
  }),
  ...(colorType === 'gray' && {
    backgroundColor: '#E5E7EB',
    color: '#374151',
    '&:hover': { backgroundColor: '#D1D5DB' },
  }),
  ...(colorType === 'red' && {
    borderColor: '#EF4444',
    color: '#EF4444',
    '&:hover': { backgroundColor: '#FEF2F2', borderColor: '#DC2626' },
  }),
}));
